import { render, staticRenderFns } from "./deanDialogButtonGroup.vue?vue&type=template&id=91a0e39e&scoped=true"
import script from "./deanDialogButtonGroup.vue?vue&type=script&lang=ts"
export * from "./deanDialogButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./deanDialogButtonGroup.vue?vue&type=style&index=0&id=91a0e39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a0e39e",
  null
  
)

export default component.exports